// extracted by mini-css-extract-plugin
export default {"tagList":"style_tagList__8QaeR","tagItem":"style_tagItem__6L-zf","tagItemSelected":"style_tagItemSelected__sr55y"};